import React from 'react';
import './cloumn.scss';
import { AonCheckbox } from '../../../../components/core/AonCheckbox';
import { formatDate } from '../../../../constants/utilities';
import { useClientPageStore } from '../../../../store';
var ColumnTitle;
(function (ColumnTitle) {
    ColumnTitle["Selected"] = "Selected Staff(s)";
    ColumnTitle["user"] = "User";
    ColumnTitle["dateAdded"] = "Date Added";
    ColumnTitle["lastLogin"] = "Last Login";
})(ColumnTitle || (ColumnTitle = {}));
;
export var columns = function (onClickSelected, sortBy, sortColumn, handleSorting, apiLoading) {
    var SelectedMarketCell = function (info) {
        var style = info.node.rowHeight === 30 ? { marginTop: "3px" } : { marginTop: "12px" };
        var clientStore = useClientPageStore();
        return (React.createElement("span", null,
            React.createElement(AonCheckbox, { disabled: !clientStore.isUserHaveFullAccess, style: style, onClick: function (event) { return onClickSelected(event, info.node.rowIndex); }, checked: info.data.selected })));
    };
    var DateCell = function (info) { return (React.createElement("span", null, formatDate(info.getValue()))); };
    var headerConfig = function (headerProps) {
        var classsName = sortColumn === headerProps.column.colId ? "sorting-".concat(sortBy, " active sorting-height") : "sorting sorting-height";
        return (React.createElement("div", { onClick: function () { return apiLoading ? null : handleSorting(headerProps.column.colId); }, className: classsName },
            React.createElement("span", null, headerProps.displayName)));
    };
    var CenterAlline = {
        display: "flex",
        justifyContent: "center"
    };
    return ([
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "Selected_Market", cellRenderer: SelectedMarketCell, headerName: ColumnTitle.Selected, sortable: false, flex: 0.5, minWidth: 150 },
        { field: "accountName", headerName: ColumnTitle.user, sortable: false, flex: 1, minWidth: 150, headerComponent: headerConfig },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "createdDate", cellRenderer: DateCell, headerName: ColumnTitle.dateAdded, sortable: false, flex: 1, minWidth: 150, headerComponent: headerConfig },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "lastRunDate", cellRenderer: DateCell, headerName: ColumnTitle.lastLogin, sortable: false, flex: 1, minWidth: 150, headerComponent: headerConfig },
    ]);
};
